<script>
    import {texturesUrl} from "../urls";

    export let modelUrl = null;

    let currentModelUrl = null;

    $: {
        if (currentModelUrl !== modelUrl) {
            currentModelUrl = modelUrl;

            if (currentModelUrl != null) load(currentModelUrl);
        }
    }

    import {onDestroy, onMount} from "svelte";

    import * as THREE from "three";

    import {OrbitControls} from "three/examples/jsm/controls/OrbitControls.js";
    import {FBXLoader} from "../customFbxLoader.js";

    let camera, scene, renderer, controls, material, container, grid;
    let models = [];
    let mixer;

    onMount(() => {
        THREE.Cache.enabled = true;
        init();
        animate();
    });

    onDestroy(() => {
        THREE.Cache.enabled = false;
        THREE.Cache.clear();
    })

    function init() {
        camera = new THREE.PerspectiveCamera(
            45,
            window.innerWidth / window.innerHeight,
            1,
            4000
        );
        camera.position.set(1000, 500, 0);

        scene = new THREE.Scene();
        scene.background = new THREE.Color();

        const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x444444);
        hemisphereLight.position.set(0, 200, 0);
        scene.add(hemisphereLight);

        const dirLight = new THREE.DirectionalLight(0xffffff);
        dirLight.position.set(0, 2000, 1000);
        dirLight.intensity = 1;
        dirLight.castShadow = true;
        dirLight.shadow.camera.top = 180;
        dirLight.shadow.camera.bottom = -100;
        dirLight.shadow.camera.left = -120;
        dirLight.shadow.camera.right = 120;
        scene.add(dirLight);

        // ground
        const mesh = new THREE.Mesh(
            new THREE.PlaneGeometry(2000, 2000),
            new THREE.MeshPhongMaterial({color: 0x999999, depthWrite: false})
        );
        mesh.rotation.x = -Math.PI / 2;
        mesh.receiveShadow = true;
        scene.add(mesh);

        grid = new THREE.GridHelper(2000, 2000, 0x000000, 0x000000);
        grid.material.opacity = 0.2;
        grid.material.transparent = true;
        scene.add(grid);

        renderer = new THREE.WebGLRenderer({antialias: true});
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(500, 400);
        renderer.shadowMap.enabled = true;
        container.appendChild(renderer.domElement);

        controls = new OrbitControls(camera, renderer.domElement);
        controls.autoRotateSpeed *= -1;
    }

    const clock = new THREE.Clock()

    function load(url) {
        let model;
        while ((model = models.pop())) scene.remove(model);

        const loader = new FBXLoader();
        loader.withCredentials = true;
        loader.setResourcePath(texturesUrl())

        loader.load(url, function (object) {
            object = object.sceneGraph
            models.push(object);

            if (object.animations && object.animations.length){
                mixer = new THREE.AnimationMixer(object);
                const action = mixer.clipAction(object.animations[0]);
                action.reset();
                action.setLoop(true);
                action.play();
            } else {
                mixer = null;
            }

            object.traverse(function (child) {
                if (child.isMesh) {
                    child.castShadow = true;
                    child.receiveShadow = true;
                }
            });

            scene.add(object);

            const box = new THREE.Box3().setFromObject(object);
            const center = new THREE.Vector3();
            box.getCenter(center);

            let sphere = new THREE.Sphere();
            box.getBoundingSphere(sphere);

            let maxDistance = sphere.radius * 3;

            controls.target.set(center.x, center.y, center.z);
            controls.maxDistance = maxDistance;
            controls.update();

            grid.position.set(center.x, 0, center.z);

            camera.position.set(1000, 500, 0);
        });
    }

    function onWindowResize() {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(container.clientWidth, container.clientHeight);
    }

    function animate() {
        requestAnimationFrame(animate);

        controls.update();
        if (mixer)
            mixer.update(clock.getDelta())

        renderer.render(scene, camera);
    }
</script>

<div bind:this={container}></div>
